import { render } from "./azureAuthentication.vue?vue&type=template&id=04beed64&scoped=true"
const script = {}

import "./azureAuthentication.vue?vue&type=style&index=0&id=04beed64&scoped=true&lang=css"

import exportComponent from "/Users/michael/Desktop/Development/vue/godservice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04beed64"]])

export default __exports__